import styled from 'styled-components';

export const Content = styled.div`
  padding: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
`;
